export const AuthenticationEnum = Object.freeze({
  PASSWORD: 'PASSWORD'/*,
  SSH_KEY: 'SSH_KEY'*/
});